import React, { useState, useEffect, useContext } from "react";
import { TranslatorContext } from "../../context/Translator";
import { Link } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import { FloatCardComponent } from "../../components/cards";
import MisGirasTableComponent from "../../components/tables/MisGirasTableComponent";

import PageLayout from "../../layouts/PageLayout";
import products from "../../assets/data/misgiras.json";

import {getMisGiras}  from "../../api/giras.ts";

export default function MisGirasListPage() {

    const { t, n } = useContext(TranslatorContext)
    
    const floats = [
        { "title": "total_products", "digit": 547, "icon": "shopping_bag", "variant": "lg blue" }, 
        { "title": "total_categories", "digit": 605, "icon": "widgets", "variant": "lg green" },
        { "title": "total_barnds", "digit": 249, "icon": "verified_user", "variant": "lg purple" }
    ]

    const [giras, setGiras] = useState([]);

    useEffect(() => {
         const fetchTabla = async () => {
             const res = await getMisGiras();
             setGiras(res);
         }
    
         fetchTabla();   
               
     }, []);

    return (
        <PageLayout>
            <Row>
               
                <Col xl={12}>
                    <div className="mc-card">
                        <div className='mc-breadcrumb'>
                            <h3 className="mc-breadcrumb-title">Mis Giras</h3>
                            <ul className="mc-breadcrumb-list">
                                <li className="mc-breadcrumb-item"><Link to='#' className="mc-breadcrumb-link">{t('home')}</Link></li>
                              
                                <li className="mc-breadcrumb-item">Giras</li>
                            </ul>
                        </div>
                    </div>
                </Col>
               
                <Col xl={12} >
                    <div className="mc-card">
                        <Row  style={{ height: '650px' }}>
                            
                            <Col xl={12}>
                                <MisGirasTableComponent 
                                    thead={ products.thead } 
                                    data={giras}
                                />
                                <MisGirasTableComponent />
                            </Col>
                        </Row>
                    </div>
                </Col>
            </Row>
        </PageLayout>
    );
}
